import { resolveLocale } from '../utils/localisation/locales.js';
import {
    getLocalStorageItem,
    setLocalStorageItem,
} from '../utils/safe-storage';

const lang = resolveLocale(getLocalStorageItem('locale'));

const parseTours = () => {
    try {
        return JSON.parse(getLocalStorageItem('tours')) || null;
    } catch (error) {
        return null;
    }
};

const tours = parseTours();

const defaultToursState = {
    welcomeTour: 'incomplete',
    totalStepsLeft: null,
};

if (!tours || !Object.keys(tours).length) {
    setLocalStorageItem('tours', JSON.stringify(defaultToursState));
}

export const initialState = {
    login: {
        errorMessage: '',
        isLoggedin: false,
        isLoggingIn: false,
        loginMessage: '',
        redirectUrl: null,
        activationMessage: '',
        activationStatus: '',
        requires2FA: false,
    },
    register: {
        errorMessage: '',
        isRegistered: false,
        isRegistering: false,
        registrationMessage: '',
    },
    candidates: {
        activeCandidateId: null,
        activeReferenceId: null,
        byId: null,
        filterData: {
            users: [],
            teams: [],
            tags: [],
        },
        list: [],
        isFiltered: false,
        loadingCandidates: false,
        failedCandidatesRequest: null,
        candidatesRequestId: null,
        hasMoreCandidates: true,
        requestSettings: {
            isLoading: false,
            isUpdating: false,
            error: null,
            data: null,
        },
        editRequestModalOpen: false,
    },
    inbound: {
        loading: false,
    },
    referencingDashboard: {
        loading: false,
    },
    referenceRequest: {
        isPostingRequest: false,
        message: '',
        status: '',
        requestCreated: false,
        requestUrl: '',
        requestId: '',
        errors: {},
        isFetchingProfileList: false,
        questionProfileList: [],
        questionProfileListError: '',
        questionPreview: {
            isFetchingProfile: false,
            profile: {},
            profileErrorMessage: '',
        },
    },
    user: {
        email: '',
        organisation: '',
        isUpdating: false,
        message: '',
        error: '',
        isLoggedin: 0,
        isFetchingUser: false,
        fetchedUser: false,
        roleid: null,
        isAdmin: null,
        isSuperAdmin: null,
        tours: tours || defaultToursState,
    },
    usersAndTeams: {
        loadingTeams: false,
        loadingUsers: false,
        teams: [],
        users: [],
        savedTeam: false,
        savedUser: false,
        savingTeam: false,
        savingUser: false,
        deletingUser: false,
        deletingTeam: false,
        resetting2FA: false,
    },
    site: {
        deviceWidth: null,
        deviceHeight: null,
        isMobileView: false,
        isMobileDevice: false,
        isOnline: false,
        error: null,
    },
    questionStore: {
        isCreatingProfile: false,
        isFetchingProfiles: false,
        isFetchingProfile: false,
        isFetchingProfileList: false,
        savingNewProfile: false,
        newProfileSaved: false,
        profileSavedMessage: '',
        profileErrorMessage: '',
        profiles: [],
        profileList: [],
        profilesErrorMessage: null,
        profileListErrorMessage: null,
        currentProfile: {
            name: '',
            qpid: 0,
            teamname: '',
            questions: [],
            isDeletingQuestion: false,
            isDeletingProfile: false,
            deleteQuestionSuccessMessage: '',
            deleteQuestionErrorMessage: '',
            questionId: null,
            createdQuestionErrorMessage: '',
            createdQuestionSuccessMessage: '',
            createdQuestion: false,
            profileDeletedMessage: null,
            profileDeleted: false,
            errorDeletingProfileMessage: null,
            isSavingQuestion: false,
            isCreatingQuestion: false,
        },
    },
    locales: {
        locale: lang || 'en-gb',
    },
    talentPool: {
        list: [],
        stats: {
            total: 0,
            with_personal_email: 0,
            unique_job_titles: 0,
            recent_opt_ins: 0,
        },
        filters: {
            jobtitles: [],
        },
        loading: false,
        deleting: false,
        hasMoreSubscribers: false,
        errors: {
            message: null,
            deleteMessage: null,
        },
        deleteStatus: {
            successCount: 0,
            failureCount: 0,
            message: null,
        },
    },
    vacancyPool: {
        list: [],
        loading: false,
        loadingMore: false,
        hasMoreSubscribers: false,
        deleting: false,
        deleteStatus: {
            successCount: 0,
            failureCount: 0,
            message: null,
        },
        errors: {
            message: null,
        },
    },
    settings: {
        loading: false,
        updating: false,
        twoFactor: {
            isSettingUp: false,
            isEnabling: false,
            isDisabling: false,
            secret: null,
            qrUrl: null,
            otpauthUri: null,
            setupError: null,
            enableError: null,
            disableError: null,
        },
    },
    subscription: {
        submittingSubscription: false,
        products: {
            addons: {},
            credits: {},
        },
        type: 'month',
        stage: '',
        items: [],
        proration: '',
        subTotal: 0,
        taxTotal: 0,
        startingBalance: 0,
        total: 0,
        amountDue: 0,
    },
    topUp: {
        products: [],
        loading: false,
    },
};
